import {  EntityRepository, Repository } from "typeorm";
import { InsuranceEntity } from "./insurance.entity";


@EntityRepository(InsuranceEntity)
export class InsuranceRepository extends Repository<InsuranceEntity>{
    
}
